export default "__VITE_ASSET__d26e3c03__"